import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastComponent } from '@ui-lib/components';

@Component({
  standalone: true,
  imports: [RouterModule, ToastComponent],
  selector: 'mon-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
